import { render, staticRenderFns } from "./activityTypeForm.vue?vue&type=template&id=5cda27e7"
import script from "./activityTypeForm.vue?vue&type=script&lang=js"
export * from "./activityTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports